export const buttonLabels = {
    more: {
        ARM: "Ավելին",
        ENG: "More",
        RUS: "Более"
    },
    send: {
        ARM: "Ավելին",
        ENG: "send",
        RUS: "Более"
    }
}

export const regularNavBar = {
    home: {
        ARM: "գլխավոր էջ",
        ENG: "home",
        RUS: "домашняя страница"
    },
    aboutUS: {
        ARM: "Մեր մասին",
        ENG: "About Us",
        RUS: "О нас"
    },
    activities: {
        ARM: "Գործունեություն",
        ENG: "Activities",
        RUS: "Деятельность"
    },
    products: {
        ARM: "Ապրանքներ",
        ENG: "Products",
        RUS: "Продукты"
    },
    contacts: {
        ARM: "կապ",
        ENG: "Our Contacts",
        RUS: "Наши контакты"
    }
}